export default __webpack_public_path__ + "ee33a3ee06cd21c477442f1950b4b4e4.png";